import httpClient from "../../clients/httpClient";
import { IHomePageTile, IHomePageTilePayload } from "../../interfaces/home-page-tile.interface";
import { IHomePageProductFilterPayload } from "../../interfaces/homepage-product-filters";

export const reorderHomePageProductFilterStore = (
    storeId: number,
    newOrder: number[]
) => {
    return httpClient.patch<IHomePageTile[]>(
        `/api/v1/stores/${storeId}/homepage-product-filter/reorder`,
        { newOrder }, {
            params: {
                is_web: true
            }
        }
    );
};

export const updateHomePageProductFilterStore = (
    storeId: number,
    id: number,
    payload: any
) => {
    return httpClient.patch<IHomePageTile>(
        `/api/v1/stores/${storeId}/homepage-product-filter/${id}`,
        payload
    );
};

export const deleteHomePageProductFilterStore = (
    storeId: number,
    id: number
) => {
    return httpClient.delete(
        `/api/v1/stores/${storeId}/homepage-product-filter/${id}`
    );
};

export const createHomePageProductFilterStore = (
    storeId: number,
    payload: any
) => {
    return httpClient.post<IHomePageTile>(
        `/api/v1/stores/${storeId}/homepage-product-filter`,
        payload
    );
};

export const createHomePageProductFilterStoreV2 = (
    storeId: number,
    payload: IHomePageTilePayload
) => {
    return httpClient.post<IHomePageTile>(
        `/api/v2/stores/${storeId}/homepage-product-filter`,
        payload
    );
};

export const updateHomePageProductFilterStoreV2 = (
    storeId: number,
    id: number,
    payload: IHomePageTilePayload
) => {
    return httpClient.patch<IHomePageTile>(
        `/api/v2/stores/${storeId}/homepage-product-filter/${id}`,
        payload
    );
};

export const getStoreHomePageFilters = (id: string) => {
    return httpClient.get<IHomePageTile[]>(`/api/v1/stores/${id}/homepage-product-filter`, {
        params: {
            is_web: true
        }
    });
};

export const toggleStatusHomePageProductFilterStoreV2 = (
    storeId: number,
    id: number,
    isActive: boolean
) => {
    return httpClient.patch<IHomePageTile>(
        `/api/v2/stores/${storeId}/homepage-product-filter/${id}/toggle-status`,
        { is_active: isActive }
    );
};